import moment from 'moment';

export function startOfDay() {
  return moment().hour(0).minute(0).second(0).millisecond(0);
}

export function zeroDate(date, end) {
  if (end) {
    return moment(date).hour(23).minute(59).second(59).millisecond(999);
  }
  return moment(date).hour(0).minute(0).second(0).millisecond(0);
}



// WEBPACK FOOTER //
// ./src/utils/Date.js